import Vue from 'vue'
import Router from 'vue-router'
import Home from "@/views/Home";
import Home_en from "@/views/Home_en";

Vue.use(Router)


const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  mode: 'hash',

  routes: [
    {// 404路由
      path: '*',
      redirect: '/404'
    },
    //默认
    {
      path: '/',
      redirect: '/index'
    },
    {
      path: '/main',
      name: 'main',
      component: () => import( '@/views/main.vue'),
      children: [ //首页
        {
          path: '/index',
          name: 'index',
          component: Home
        },
        {
          path: '/SinglePage',
          name: 'SinglePage',
          component: () => import('@/views/SinglePage.vue')
        },
      ]
    },
	{
      path: '/main_en',
      name: 'main_en',
      component: () => import( '@/views/main_en.vue'),
      children: [ //Homepage
        {
          path: '/index_en',
          name: 'index_en',
          component: Home_en
        },
        {
          path: '/SinglePage_en',
          name: 'SinglePage_en',
          component: () => import('@/views/SinglePage_en.vue')
        },
      ]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js